import { useQuery, QueryFunction } from 'react-query';
import { getAllLoadNatures, GetLoadNaturesQueries, LoadNature } from '../../services/apiSLTP/materials/loadNatures';

type UseLoadNaturesQueryOptions = {
    queries?: GetLoadNaturesQueries;
};

const getLoadNatures: QueryFunction<LoadNature[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseLoadNaturesQueryOptions];
    const { queries } = options;

    const response = await getAllLoadNatures(queries);
    return response.data;
};

export const useLoadNaturesQuery = (options: UseLoadNaturesQueryOptions) => {
    return useQuery(['loadNatures', options], getLoadNatures);
};
